export { default as GaugeSurvey } from './GaugeSurvey';
export { default as WxDoctorApi } from './WxDoctorApi';
export { default as DiseaseManage } from './DiseaseManage';
export { default as QRActionApi } from './QRActionApi';
export { default as WeChatDoctor } from './WeChatDoctor';
export { default as WeChatPatient } from './WeChatPatient';
export { default as SignInApi } from './SignInApi';
export { default as PasswordApi } from './PasswordApi';
